import { InjectionToken } from '@angular/core';
import { FairsConfiguration, LandingpageConfiguration } from '@planone/bau365/data-access-fair-data';
import { UnleashConfiguration } from '@planone/shared/data-access-feature-flags';
import { LoggingConfiguration } from '@planone/shared/util-logging';
import { TrackerConfiguration } from '@snowplow/browser-tracker-core';

export interface EnvironmentInterface {
  production: boolean;
  defaultFairId: string;
  keycloakUrl: string;
  keycloakClient: string;
  fairDataGatewayUrl: string;
  searchUrl: string;
  userUrl: string;
  ticketUrl: string;
  analyticsUrl: string;
  exportServiceUrl: string;
  leadServiceUrl: string;
  basicAuth: string;
  host: string;
  selfserviceHost: string;
  iconHost: string;
  platformTitle: string;
  mockApiResponses: {
    globally: boolean;
    modules: { [module: string]: boolean };
  };
  trackers: {
    snowplow: {
      queue: boolean;
      trackerConfig: TrackerConfiguration;
      trackerId: string;
      endpoint: string;
    };
    googleAnalytics: {
      property: string;
    };
  };
  fairsConfiguration: FairsConfiguration;
  landingpageConfiguration: LandingpageConfiguration;
  unleash: UnleashConfiguration;
  sentry: LoggingConfiguration;
  botRegex: RegExp;
  spaceRegex: RegExp;
}

export const ENVIRONMENT = new InjectionToken<EnvironmentInterface>('ENVIRONMENT');
